import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { useInView } from "react-intersection-observer";

// components
import Button from "../../Button/Button";
import FourCards from "../../Cards/FourCards";

// styles
import * as styles from "./AiDigitalTwin.module.css";

const AiDigitalTwin = ({ cardsData, onCtaClick }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Handle CTA click
  const handleCtaClick = e => {
    if (onCtaClick) {
      onCtaClick(e);
    }
  };

  return (
    <section className={styles.aiDigitalTwinWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        {/* Banner Section */}
        <div className={styles.bannerSection}>
          <div className={styles.bannerImageDesktop}>
            <StaticImage
              src="../../../images/home/ai_digital_twin_banner.png"
              alt="AI Digital Twin India - Meet Your AI digital twin™"
              placeholder="blurred"
              loading="lazy"
            />
          </div>
          <div className={styles.bannerImageMobile}>
            <StaticImage
              src="../../../images/home/ai_twin_banner_mob.png"
              alt="AI Digital Twin India - Meet Your AI digital twin™"
              placeholder="blurred"
              loading="lazy"
            />
          </div>

          {/* Learn More Button */}
          <div className={styles.learnMoreSection}>
            <Button
              text="Learn More"
              href="/contact/"
              variant="primary"
              onClick={handleCtaClick}
              btnClass={styles.learnMoreBtn}
            />
          </div>
        </div>

        {/* Cards Section */}
        <div className={styles.cardsSection}>
          <FourCards cards={cardsData} />
        </div>
      </div>
    </section>
  );
};

export default AiDigitalTwin;
